import React from 'react';
import { IGPDetail } from 'types/operation';
import { getGPDetail } from 'api/operation/group';

const useOpsGroupDetail = (id?: number): [IGPDetail | undefined, boolean, () => void] => {
    const [loading, setLoading] = React.useState(false);
    const [item, setItem] = React.useState<IGPDetail>();
    const fetchData = async () => {
        try {
            setLoading(true);
            const result = await getGPDetail(id!);
            if (!result.error) {
                setItem(result.data?.data);
            }
            setLoading(false);
        } catch (e) {
            console.error(e);
            setLoading(false);
        }
    };
    React.useEffect(() => {
        if (!loading && id) {
            fetchData();
        }
    }, [id]);

    return [item, loading, fetchData];
};

export default useOpsGroupDetail;
